module.exports = __webpack_public_path__ + "img/zntj@2x.77625901.png";